<template>
  <div class="form-group" :id="id">
    <div>
      Früheste mögliche Nachricht nach
    </div>
    <div class="row">
      <div class="col col-4">
        <label :for="`${id}days_min`">
          {{ days[0] | days }}
        </label>
        <vue-slider
          tooltip="false"
          :min="min"
          :max="max"
          step="1"
          :id="`${id}days_min`"
          v-model="days[0]"
          @input="emit"
        ></vue-slider>
      </div>
      <div class="col col-4">
        <label :for="`${id}hours_min`">
          {{ hours[0] | hours }}
        </label>
        <vue-slider
          tooltip="false"
          :min="0"
          :max="23"
          step="1"
          :id="`${id}hours_min`"
          v-model="hours[0]"
          @input="emit"
        ></vue-slider>
      </div>
      <div class="col col-4">
        <label :for="`${id}minutes_min`">
          {{ minutes[0] | minutes }}
        </label>
        <vue-slider
          tooltip="false"
          :min="0"
          :max="59"
          step="1"
          :id="`${id}minutes_min`"
          v-model="minutes[0]"
          @input="emit"
        ></vue-slider>
      </div>
    </div>
    <div>
      Zusätzlich Maximal mögliche Verzögerung
    </div>
    <div class="row">
      <div class="col col-4">
        <label :for="`${id}days_max`">
          {{ days[1] | days }}
        </label>
        <vue-slider
          tooltip="false"
          :min="min"
          :max="max"
          step="1"
          :id="`${id}days_max`"
          v-model="days[1]"
          @input="emit"
        ></vue-slider>
      </div>
      <div class="col col-4">
        <label :for="`${id}hours_max`">
          {{ hours[1] | hours }}
        </label>
        <vue-slider
          tooltip="false"
          :min="0"
          :max="23"
          step="1"
          :id="`${id}hours_max`"
          v-model="hours[1]"
          @input="emit"
        ></vue-slider>
      </div>
      <div class="col col-4">
        <label :for="`${id}minutes_max`">
          {{ minutes[1] | minutes }}
        </label>
        <vue-slider
          tooltip="false"
          :min="0"
          :max="59"
          step="1"
          :id="`${id}minutes_max`"
          v-model="minutes[1]"
          @input="emit"
        ></vue-slider>
      </div>
    </div>
    <div :for="id">
      Früheste Nachricht möglich nach: {{ days[0] }} Tagen
      {{ hours[0] }} Stunden {{ minutes[0] }} Minuten
      <br />
      Späteste Nachricht möglich nach: {{ days[0] + days[1] }} Tagen
      {{ hours[0] + hours[1] }} Stunden {{ minutes[0] + minutes[1] }} Minuten
    </div>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import { uniqueId } from "lodash";

export default {
  data() {
    return {
      id: uniqueId("date-range-selector"),
      days: [0, 30],
      hours: [0, 23],
      minutes: [0, 59],
      count: 0
    };
  },
  mounted() {
    this.updateTime();
  },
  computed: {
    max() {
      return this.attribute.max;
    },
    min() {
      return this.attribute.min;
    }
  },
  methods: {
    updateTime() {
      let value = { min: 0, max: 44639 };
      if (this.value) {
        value = { ...this.value };
      }

      value.max -= value.min;
      this.days = [
        Math.floor(value.min / 24 / 60),
        Math.floor(value.max / 24 / 60)
      ];
      this.hours = [
        Math.floor((value.min / 60) % 24),
        Math.floor((value.max / 60) % 24)
      ];
      this.minutes = [value.min % 60, value.max % 60];
    },
    emit() {
      let min = this.minutes[0] + this.hours[0] * 60 + this.days[0] * (60 * 24);
      let max =
        this.minutes[1] + this.hours[1] * 60 + this.days[1] * (60 * 24) + min;
      this.$emit("input", { min, max });
    }
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    }
  },
  watch: {
    value() {
      this.updateTime();
    }
  },
  filters: {
    days(val) {
      return `${val} ${val === 1 ? "Tag" : "Tage"}`;
    },
    hours(val) {
      return `${val} ${val === 1 ? "Stunde" : "Stunden"}`;
    },
    minutes(val) {
      return `${val} ${val === 1 ? "Minute" : "Minuten"}`;
    }
  }
};
</script>
